import { SvgIcon, SvgIconProps } from '@mui/material'

/* eslint-disable max-len */
export const PetAddOnIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} data-testid="PetAddOnIcon">
      <g clipPath="url(#clip0_10748_63570)">
        <path d="M4.5 12C5.88071 12 7 10.8807 7 9.5C7 8.11929 5.88071 7 4.5 7C3.11929 7 2 8.11929 2 9.5C2 10.8807 3.11929 12 4.5 12Z" />
        <path d="M9 8C10.3807 8 11.5 6.88071 11.5 5.5C11.5 4.11929 10.3807 3 9 3C7.61929 3 6.5 4.11929 6.5 5.5C6.5 6.88071 7.61929 8 9 8Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.4 4.79753C17.0964 3.75879 16.1368 3 15 3C13.6193 3 12.5 4.11929 12.5 5.5C12.5 6.88071 13.6193 8 15 8C16.1368 8 17.0964 7.24121 17.4 6.20247V4.79753Z"
        />
        <path d="M19.5 12C20.8807 12 22 10.8807 22 9.5C22 8.11929 20.8807 7 19.5 7C18.1193 7 17 8.11929 17 9.5C17 10.8807 18.1193 12 19.5 12Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4435 13.8055C16.7332 14.1469 17.0275 14.4938 17.3399 14.86C17.4178 14.9379 17.4968 15.0163 17.5764 15.0953C18.8346 16.3446 20.2415 17.7413 19.9499 19.66C19.6599 20.67 18.9299 21.69 17.6199 21.98C17.2839 22.0444 16.6091 21.9564 15.7367 21.8425C14.7135 21.709 13.4186 21.54 12.0799 21.54H11.8999C10.5725 21.54 9.28807 21.709 8.26896 21.8431C7.38405 21.9596 6.69917 22.0497 6.3599 21.98C5.0499 21.69 4.3199 20.68 4.0299 19.66C3.74788 17.7516 5.15381 16.3559 6.41165 15.1071C6.49183 15.0275 6.5714 14.9485 6.6499 14.87C7.21397 14.2162 7.7164 13.624 8.23359 13.0145C8.52326 12.6731 8.81756 12.3262 9.1299 11.96C9.5999 11.42 10.1799 10.88 10.8799 10.64C10.9899 10.6 11.0999 10.57 11.2099 10.55C11.4699 10.5 11.7399 10.5 11.9999 10.5C12.2599 10.5 12.5299 10.5 12.7799 10.54C12.8899 10.56 12.9999 10.59 13.1099 10.63C13.8099 10.87 14.3999 11.41 14.8599 11.95C15.424 12.6038 15.9264 13.196 16.4435 13.8055ZM11.25 13H12.75V15.2516H15V16.7526H12.75V18.9967C12.75 18.9967 11.2575 19.0042 11.25 18.9967V16.7526H9C9 16.7526 9.0075 15.2591 9 15.2516H11.25V13Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_10748_63570">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}
